import { badgeVariants } from "@/components/ui/badge";
import type { VariantProps } from "class-variance-authority";

export enum ActivityLogStatus {
  COMPLETED = "COMPLETED",
  TO_DO = "TO DO",
  IN_PROGRESS = "IN_PROGRESS",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
  CANCELLED = "CANCELLED",
}

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>["variant"]>;

const normalizeStatus = (status: string): string =>
  status.trim().replace(/\s+/g, " ").toUpperCase();

const STATUS_VARIANT_MAP: Record<ActivityLogStatus, BadgeVariant> = {
  [ActivityLogStatus.COMPLETED]: "status_done",
  [ActivityLogStatus.TO_DO]: "status_new",
  [ActivityLogStatus.IN_PROGRESS]: "status_in_progress",
  [ActivityLogStatus.APPROVED]: "status_approved",
  [ActivityLogStatus.CANCELED]: "status_canceled",
  [ActivityLogStatus.CANCELLED]: "status_canceled",
};

export const statusToBadgeVariant = (status: string): BadgeVariant => {
  const normalized = normalizeStatus(status);
  return STATUS_VARIANT_MAP[normalized as ActivityLogStatus] ?? "status_new";
};
